














import { defineComponent } from '@vue/composition-api'
import HeaderPane from '@/components/common/Header/HeaderPane.vue'
import NotificationPane from '@/components/NotificationPane/NotificationPane.vue'

/**
 * NOTIFICATION 通知ページ
 */
export default defineComponent({
  name: 'NotificationPage',
  components: {
    NotificationPane,
    HeaderPane,
  },
  props: {
    /**
     * ヘッダーナビ表示指定
     */
    hasHeaderNav: {
      type: Boolean,
      default: true,
    },
  },
})
